import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { breakpoints, colors, IconSize } from "@/styles/utils/vars";
import { ButtonBase, cssButtonBackward } from "@/ui/Button/StyledButton";
import { StyledEntityImage } from "@/ui/EntityImage/Styled";
import { cssIcon, getSizeSVG } from "@/ui/Icon";
import { StyledLinkBase } from "@/ui/Link/StyledLink";
import { getTypographyBase, Paragraph16, Span } from "@/ui/Typography/Typography";
import { StyledList } from "../../../List/StyledList";
export const StyledCategoryLink = /*#__PURE__*/styled(Span)({
  name: "StyledCategoryLink",
  class: "StyledCategoryLink_s1731myq"
});
export const StyledCategoryName = /*#__PURE__*/styled(Span)({
  name: "StyledCategoryName",
  class: "StyledCategoryName_sww9s7d"
});
export const cssIsSelectedCategory = "cssIsSelectedCategory_cc5ywy6";
export const cssAngle = "cssAngle_ce61vs7";
export const StyledCategoryHeader = /*#__PURE__*/styled('div')({
  name: "StyledCategoryHeader",
  class: "StyledCategoryHeader_s161g10q"
});
export const StyledCategoryImage = /*#__PURE__*/styled('div')({
  name: "StyledCategoryImage",
  class: "StyledCategoryImage_s1s1xsld"
});
export const StyledCategoryTitle = /*#__PURE__*/styled(Paragraph16)({
  name: "StyledCategoryTitle",
  class: "StyledCategoryTitle_snb6src"
});
export const cssWithExpanded = "cssWithExpanded_cscgbn8";
export const cssIsExpanded = "cssIsExpanded_c1iktpus";
export const StyledCategory = /*#__PURE__*/styled('div')({
  name: "StyledCategory",
  class: "StyledCategory_s1x9vldu"
});
export const StyledCategoryQty = /*#__PURE__*/styled(Span)({
  name: "StyledCategoryQty",
  class: "StyledCategoryQty_stbgogm"
});
export const StyledCategoryFooter = /*#__PURE__*/styled('div')({
  name: "StyledCategoryFooter",
  class: "StyledCategoryFooter_s1xhnl45"
});
export const StyledCategoryContainer = /*#__PURE__*/styled('div')({
  name: "StyledCategoryContainer",
  class: "StyledCategoryContainer_sudjyuf"
});

require("./StyledCategory.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledCategory.tsx");